import { createContext } from 'react';
export const downtimeContext = /*#__PURE__*/createContext({
  features: [],
  polling: 0,
  featuresLoading: false
});